export default __webpack_public_path__ + "static/media/StarTheFigureImage.dd356e0f.png";